import pickBy from 'lodash/pickBy'
import { STORAGE_KEY } from '../constants'
import {
  CARDTYPES,
  DAYS,
  EVENT_TYPES,
  EVENT_TYPES_VALUES,
  EVENT_TYPES_VALUES_LOGS,
  MONTHNAME,
  MONTH_NAMES,
} from '../constants/globalConstants'
import moment from 'moment'
import SingEvent from '../assets/img/sing-event.png'
import EventPass from '../assets/img/event-pass.jpg'
import HalfSeason from '../assets/img/half-season.jpg'
import SixPack from '../assets/img/six-pack.jpg'
// import Visa from '../assets/img/visa.png'
import Visa_credit from '../assets/img/visa_credit.png'
import Master from '../assets/img/mastercard.png'
// import Maestro from '../assets/img/maestro.png'
import BlankCard from '../assets/img/blank_card.png'
import getConfigDetails from '../services/config'
import DefaultEventImage from '../assets/img/default-event.png'
import DefaultPassImage from '../assets/img/pass-no-img.jpg'

// const iOS =
//   [
//     'iPad Simulator',
//     'iPhone Simulator',
//     'iPod Simulator',
//     'iPad',
//     'iPhone',
//     'iPod',
//   ].includes(navigator.platform) ||
//   (navigator.userAgent.includes('Mac') && 'ontouchend' in document)

let userAgent = navigator.userAgent || navigator.vendor
 const iOS = (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
 ? true:false
 
//   Sat Apr 01 2023 17:05:00 GMT+0530 (India Standard Time)
export const formatDate = (date) => {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = MONTH_NAMES[newDate.getMonth()] + ' ' + newDate.getDate()
  } else {
    let format_date = new Date(date)
    date_final =
      MONTH_NAMES[format_date.getMonth()] + ' ' + format_date.getDate()
  }
  return date_final
}

export const formatDateDays = (date) => {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = DAYS[newDate.getDay()]
  } else {
    let format_date = new Date(date)
    date_final = DAYS[format_date.getDay()]
  }
  return date_final
}

export const formatAMPM = (date) => {
  // console.log(date)
  let strTime
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    let hours = newDate.getHours()
    let minutes = newDate.getMinutes()
    let ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes ? (minutes < 10 ? '0' + minutes : minutes) : '00'
    strTime = hours + ':' + minutes + ' ' + ampm
  } else {
    let hours = new Date(date).getHours()
    let minutes = new Date(date).getMinutes()
    let ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes ? (minutes < 10 ? '0' + minutes : minutes) : '00'
    strTime = hours + ':' + minutes + ' ' + ampm
  }
  return strTime
}

export const dateFormatter = (date, format) => moment(date).format(format)
// export const dateFormatterMonth = (date, format) => moment(date).format(format)

export function formatMonthYear(date) {
  let date_final
  if (iOS) {
	let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final =
      MONTHNAME[newDate.getMonth()] + ' ' + newDate.getFullYear()
  } else {
    let format_date = new Date(date)
    date_final =
      MONTHNAME[format_date.getMonth()] + ' ' + format_date.getFullYear()
  }

  return date_final
}

export const geteventImage = (event) => {
  switch (event) {
    case EVENT_TYPES.EVENT:
      return SingEvent
    case EVENT_TYPES.BUNDLE_PASS:
      return EventPass
    case EVENT_TYPES.PARTY_PASS:
      return HalfSeason
    case EVENT_TYPES.SIMPLE:
      return SixPack
    default:
      return SingEvent
  }
}

export const getEventImageById = (event_id) => {
  switch (event_id) {
    case getConfigDetails.FULL_SEASON:
      return EventPass
    case getConfigDetails.HALF_SEASON:
      return HalfSeason
    case getConfigDetails.SIX_PACK:
      return SixPack
    default:
      return SingEvent
  }
}

export const getEventType = (event) => {
  switch (event) {
    case EVENT_TYPES.EVENT:
      return EVENT_TYPES_VALUES.EVENT
    case EVENT_TYPES.BUNDLE_PASS:
      return EVENT_TYPES_VALUES.BUNDLE_PASS
    case EVENT_TYPES.PARTY_PASS:
      return EVENT_TYPES_VALUES.PARTY_PASS
    case EVENT_TYPES.SIMPLE:
      return EVENT_TYPES_VALUES.SIMPLE
    default:
      return EVENT_TYPES_VALUES.EVENT
  }
}
// export const getEventTypeById = (event_id, log) => {
//   switch (event_id) {
//     case `${getConfigDetails.FULL_SEASON}`:
//       return log ? EVENT_TYPES_VALUES_LOGS.BUNDLE_PASS : EVENT_TYPES_VALUES.BUNDLE_PASS
//     case `${getConfigDetails.HALF_SEASON}`:
//       return  log ? EVENT_TYPES_VALUES_LOGS.PARTY_PASS : EVENT_TYPES_VALUES.PARTY_PASS
//     case `${getConfigDetails.SIX_PACK}`:
//       return log ? EVENT_TYPES_VALUES_LOGS.SIMPLE : EVENT_TYPES_VALUES.SIMPLE
//     default:
//       return log ? EVENT_TYPES_VALUES_LOGS.EVENT : EVENT_TYPES_VALUES.EVENT
//   }
// }

export const getEventTypeByPassType = (pass_type,is_full_season, log) => {
  // switch (event_id) {
   if(pass_type == EVENT_TYPES?.BUNDLE_PASS && is_full_season == 1){
      return log ? EVENT_TYPES_VALUES_LOGS.BUNDLE_PASS : EVENT_TYPES_VALUES.BUNDLE_PASS
   } else if(pass_type == EVENT_TYPES?.BUNDLE_PASS && is_full_season != 1){
      return  log ? EVENT_TYPES_VALUES_LOGS.PARTY_PASS : EVENT_TYPES_VALUES.PARTY_PASS
   } else if(pass_type == EVENT_TYPES?.PARTY_PASS){
      return log ? EVENT_TYPES_VALUES_LOGS.SIMPLE : EVENT_TYPES_VALUES.SIMPLE
   } else{
      return log ? EVENT_TYPES_VALUES_LOGS.EVENT : EVENT_TYPES_VALUES.EVENT
  }
}

export const getEventCount = (eventId) => {
  // const halfSeasonEvents = localStorage.getItem('userChooseEvents')
  const eventDetails = JSON.parse(localStorage.getItem(EVENT_TYPES?.EVENT))

  switch (eventId) {
    case getConfigDetails.HALF_SEASON:
      return eventDetails?.all_event?.length/2
    case getConfigDetails.FULL_SEASON:
      return eventDetails?.all_event?.length
    case getConfigDetails.SIX_PACK:
      return 6
    default:
      return 1
  }
}

export const getSanitizedValues = (values) =>
  pickBy(values, (value) => {
    const expression = !(
      value === 0 ||
      value === '' ||
      value === undefined ||
      value === null ||
      Number.isNaN(value) ||
      value?.length === 0
    )
    return expression
  })

const setLocalStorage = (userData) => {
  userData.map((data) => {
    localStorage.setItem(data.key, data.value)
  })
}

export const getLoginDetailFromSession = () =>
  localStorage.getItem(STORAGE_KEY.ACCESS_TOKEN)

export const getBearerToken = () => localStorage.getItem(STORAGE_KEY.ID_TOKEN)

export const setLoginDetailInSession = (loggedInUserData) => {
  const userData = [
    {
      key: STORAGE_KEY.ACCESS_TOKEN,
      value: loggedInUserData?.AccessToken,
    },
    {
      key: STORAGE_KEY.REFRESH_TOKEN,
      value: loggedInUserData?.RefreshToken,
    },
    {
      key: STORAGE_KEY.ID_TOKEN,
      value: loggedInUserData?.IdToken,
    },
    {
      key: STORAGE_KEY.TOKEN_TYPE,
      value: loggedInUserData?.TokenType,
    },
  ]
  setLocalStorage(userData)
}

export function isLoggedIn() {
  return !!localStorage.getItem('accessToken')
}

export function isArrayWithLength(arr) {
  return Array.isArray(arr) && arr.length
}

export function getAllowedRoutes(routes) {
  const role = localStorage.getItem('userRole')
  return routes.filter(({ permission }) => {
    if (!permission) return true
    else if (!isArrayWithLength(permission)) return true
    else return permission.indexOf(role) !== -1
  })
}

export function classes() {
  return [...arguments].join(' ')
}

export const clearSessionDetails = () => {
  localStorage.clear()
}

export const restrictInputValues = (event) => {
  if (!`${event.target.value}${event.key}`.match(/^[0-9]{0,6}$/)) {
    // block the input if result does not match
    event.preventDefault()
    event.stopPropagation()
    return false
}
} 

export const getPaymentCardImg = (type) => {

  switch(type){
    case CARDTYPES.VS:
		return Visa_credit
    case CARDTYPES.MC:
		return Master
		
    default:
    return BlankCard

  }

}

export const getEventLogName = (pass_type, is_full_season) => `MAPCO - BOOK NOW - ${getEventTypeByPassType(pass_type, is_full_season, 'log')}`
export const getImageUrl = (slug) => process.env.PUBLIC_URL +'/game-icons/' +slug?.replace(/ /g, '') +'.png'
export const getImage = (event) => {
	if(event){
		if(!event?.pass_type || event?.pass_type == '' ){ //Single Event
			return event?.image_url ? event?.image_url : DefaultEventImage
		}else{ //Pass 
			return event?.image_url ? event?.image_url : DefaultPassImage
		}
	}
	else{
		return DefaultPassImage
	}
	
}
	
export const validateEmail = (email) => {
  // eslint-disable-next-line no-useless-escape
  const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  return pattern.test(email)
}

export const validatePhone = (phone) => {
  // eslint-disable-next-line no-useless-escape
  // const pattern = /^[0-9]{10}$/g
  const pattern = /^(?!.(\d)\1{5,})(?!.(\d{2})\2{2,})\d{10}$/
  return pattern.test(phone)


  // let result = true
  // const pattern = /^[0-9]{10}$/g
  // if(phone && phone != ''){
  //   result = pattern.test(phone)
  // }
  // return result
}

export const isNetworkAvailable = () => {
      let result = false
      if(window.navigator.onLine)
        {
          result = true}
      else{
          result = false
      }
      return result
}

export const validExpiryDate = (value) => {
  let expiryDateCheck= value.length == 4  && value.substring(0 , 2) < 13 &&  (value.substring(0 , 2)>=moment(new Date()).format('MM') &&  value.substring(2)>=moment(new Date()).format('YY')
  || value.substring(0 , 2)<=moment(new Date()).format('MM') &&  value.substring(2)> moment(new Date()).format('YY')
)
return expiryDateCheck
}